/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

const styles = {
  appButton: {
    height: '50px',
    borderRadius: '10px',
    fontWeight: 500,
  },
};

function AppButton({
  btnText,
  variant,
  btnType,
  onClick,
  size,
  className,
  ...rest
}) {
  return (
    <button
      // eslint-disable-next-line react/button-has-type
      type={btnType}
      onClick={onClick}
      style={styles.appButton}
      className={`app-btn app-btn-${variant} app-btn-${size} ${className}`}
      {...rest}
    >
      {btnText}
    </button>
  );
}

AppButton.defaultProps = {
  className: '',
  variant: 'primary',
  btnType: 'button',
  size: 'medium',
};

AppButton.propTypes = {
  btnText: PropTypes.any.isRequired,
  onClick: PropTypes.func.isRequired,
  size: PropTypes.string,
  btnType: PropTypes.oneOf(['submit', 'button', 'reset']),
  variant: PropTypes.oneOf([
    'primary',
    'secondary',
    'outlined',
    'outlined-gray',
    'red',
    'green',
    'transparent',
    'white',
    'outlined-secondary',
  ]),
  className: PropTypes.string,
};

export default AppButton;
